/* eslint-disable no-plusplus */
import {
  nonEditable,
  textCell,
  monthHeaderCell,
  bottomLine,
  showZero,
} from "../cells";
import { HEADER_ROW_ID, ROW_HEIGHT } from "../constants";
import { formatNumber } from "@/utils/helpers";

function getHeaderRow() {
  return {
    rowId: HEADER_ROW_ID,
    height: ROW_HEIGHT,
    cells: [
      nonEditable(monthHeaderCell("No"), "trial-balance-header", "Transaction"),
      nonEditable(monthHeaderCell("Tenant Name"), "trial-balance-header ", "type"),
      nonEditable(monthHeaderCell("Cheque"), "trial-balance-header justify-content-start", "date"),
      nonEditable(monthHeaderCell("Cheque Amount"), "trial-balance-header justify-content-start", "number"),
      nonEditable(monthHeaderCell("Return Reason"), "trial-balance-header justify-content-start", "name"),
      nonEditable(monthHeaderCell("Date Notified"), "trial-balance-header justify-content-start", "building-name"),
      nonEditable(monthHeaderCell("Report Date of"), "trial-balance-header justify-content-start", "unit"),
      nonEditable(monthHeaderCell("Unit No."), "trial-balance-header justify-content-start", "account"),
      nonEditable(monthHeaderCell("Area"), "trial-balance-header justify-content-start", "account"),
      nonEditable(monthHeaderCell("Area"), "trial-balance-header justify-content-start", "account"),

    ]
  };
}

function getGroupRows(
  title,
  groups = []
) {
  const arrayToMap = new Array(12).fill(null);
  if (groups?.length) {
    return [
      ...groups.map((item) => ({
        rowId: item.journalEntryId,
        height: ROW_HEIGHT,
        cells: [
          nonEditable(bottomLine(textCell({ text: "13256" })), "trial-balance-row justify-content-start", "Transaction"),
          nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "type"),
          nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "date"),
          nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "number"),
          nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "name"),
          nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "building-name"),
          nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "unit"),
          nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "account"),
          nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "unit"),
          nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "account"),
        ]
      })),
      {
        rowId: `${title}Footer`,
        height: ROW_HEIGHT,
        cells: [
          nonEditable(monthHeaderCell("Total"), "trial-balance-header font-bold", "Transaction"),
          nonEditable(monthHeaderCell(""), "trial-balance-header ", "type"),
          nonEditable(monthHeaderCell(""), "trial-balance-header ", "date"),
          nonEditable(monthHeaderCell(""), "trial-balance-header ", "number"),
          nonEditable(monthHeaderCell(""), "trial-balance-header ", "name"),
          nonEditable(monthHeaderCell(""), "trial-balance-header ", "building-name"),
          nonEditable(monthHeaderCell(""), "trial-balance-header ", "unit"),
          nonEditable(monthHeaderCell(""), "trial-balance-header ", "account"),
          nonEditable(monthHeaderCell(""), "trial-balance-header ", "unit"),
          nonEditable(monthHeaderCell(""), "trial-balance-header ", "account"),
        ]
      }
    ];
  }
  return [
    ...arrayToMap.map((item, index) => ({
      rowId: index,
      height: ROW_HEIGHT,
      cells: [
        nonEditable(bottomLine(textCell({ text: "13256" })), "trial-balance-row justify-content-start", "Transaction"),
        nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "type"),
        nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "date"),
        nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "number"),
        nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "name"),
        nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "building-name"),
        nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "unit"),
        nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "account"),
        nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "unit"),
        nonEditable(showZero(textCell({ text: `${formatNumber(Math.abs(1325644))}` })), "trial-balance-row justify-content-start", "account"),
      ]
    }))
  ];
}

export function getReturnedChequeRows({
  // rowsData
}) {
  return [
    getHeaderRow(),
    ...getGroupRows(
      "Unrealized Revenue"
    ),
  ];
}
